<template>
  <Modal
    :id="'cmp-royalty-royalty_accounts-sidewindow-add_statement_form'"
    @cancelled="onCancel"
  >
    <template slot="header">
      {{ $t("add_new") }} {{ $t("statement") }}
    </template>

    <template slot="body">
      <div class="body-container">
        <div v-if="payment_yes_no > 0" class="form-group">
          <TextField
            :id="'start_date'"
            class="m1"
            v-bind="textFieldConfig"
            type="date"
            :value="statement_info.start_date"
            required
            showValidationIcons
            :placeholder="$t('start_date')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'end_date'"
            class="m1"
            v-bind="textFieldConfig"
            type="date"
            :value="statement_info.end_date"
            required
            showValidationIcons
            :placeholder="$t('end_date')"
            @valuechanged="onTextFieldValueChange"
          />
        </div>
        <span class="header-warning" v-if="!payment_yes_no"
          >Please set account base first.</span
        >
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button
        v-if="payment_yes_no"
        class="dt-button v1 s6"
        @click.stop="onOkClick"
        :disabled="!okButtonValid"
        :class="{
          disabled: !okButtonValid,
        }"
      >
        <LoadingUI v-if="submitLoading"/>
        <span v-else>{{ $t("ok") }}</span>
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import { AccountsService } from "../../services/accounts.service";
import { accountsRoyaltyGetters } from "../../store/accounts/getters";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import { NotificationService } from "@dtplugins/notification/notification.service";
import {
  confirmMessage,
  okMessage,
} from "../../../../dt-plugins/confirmation/confirmation-common";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { LoadingUI } from '@plugins/loading/loading';

export default {
  components: {
    Modal,
    InputField,
    LoadingUI,
  },
  props: ["selectedAccountDetails"],
  data() {
    return {
      statement_info: { start_date: null, end_date: null },
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
      },
      validationResult: {},

      submitLoading: false,
    };
  },
  mixins: [],
  mounted() {
    this.fetchStatementFormData();
  },
  computed: {
    royalty_account_id: function () {
      return this.$route.params.royalty_account_id;
    },
    payment_yes_no: function () {
      return this.selectedAccountDetails?.royalty_account?.payment_yes_no;
    },
    okButtonValid: function () {
      return !this.submitLoading;
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    fetchStatementFormData: async function () {
      this.submitLoading = true;
      const result = await AccountsService.fetchStatementFormData(
        this.royalty_account_id
      );
      console.log("result.data", result.data);
      this.submitLoading = false;
      this.statement_info = {
        ...result.data,
      };
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function (name, value) {
      this.statement_info[name] = value;
    },
    onOkClick: async function () {
      // Check Royalty Period Count
      this.submitLoading = true;
      
      const { no_of_rp } = await AccountsService.countRp({
        royalty_account_id: this.royalty_account_id,
        ...this.statement_info,
      });

      console.log("no_of_rp", no_of_rp);

      if (no_of_rp > 0) {
        // NotificationService.showNotification({
        //   text: this.$t('duplicate_statement_warning'),
        //   timeout: 5000,
        // });
        // return;

        const confirmationResult = await confirmMessage(
          "Warning",
          this.$t("duplicate_statement_warning")
        );
        console.log({
          "add-statement-form.vue:127 confirmationResult": confirmationResult,
        });

        if (confirmationResult != "OK") {
          this.submitLoading = false;
          return;
        }
      }

      const { status } = await AccountsService.checkStatementDate({
        royalty_account_id: this.royalty_account_id,
        ...this.statement_info,
      });
      console.log({ "add-statement-form.vue:147 status": status });
      // const status = csres.status;

      if (status != 1) {
        const confirmationResult = await ConfirmationService.createP({
          subject: "Warning",
          body: this.$t("check_royalty_dates_response"),
          width: 376,
          results: [
            {
              text: this.$t("proceed_anyway"),
              classes: "v1",
              value: "proceed_anyway",
            },
            { text: this.$t("cancel"), value: "cancel" },
          ],
        });

        if (confirmationResult != "proceed_anyway") {
          this.submitLoading = false;
          return;
        }
      }
      const { res } = await AccountsService.createStatement({
        royalty_account_id: this.royalty_account_id,
        ...this.statement_info,
      });

      // await okMessage(
      //   this.$t('notify_process_complete'),
      //   this.$t('success'),
      // );

      setTimeout(() => {
        NotificationService.showNotification({
          text: this.$t("notify_process_complete"),
          timeout: 5000,
        });
      }, 10);
      // this.submitLoading = false;
      this.$emit("added", true);
      this.onCancel();
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_accounts-sidewindow-add_statement_form {
  // border: 1px solid var(--sprt-5);
  .header-warning {
    color: var(--text-accent);
    font-size: 15px;
  }
}
</style>
